import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  importProcessingFieldText: {
    defaultMessage: 'Import Processing',
    id: 'irIRwO',
    description: 'Text to inform user which step in the process of CSV order import they are in',
  },
  importResult: {
    id: '9do6JO',
    defaultMessage: 'Import Orders',
    description: 'Title of import is processing step',
  },
  importResultSuccess: {
    id: 'JYQD+e',
    defaultMessage: 'Orders Successfully Imported',
    description: 'Title of success import',
  },
});
